import React from 'react';
import { PageHeader } from '../components/common/PageHeader';
export function MyOrders() {
  return <div className="bg-slate-50 min-h-screen pb-10 flex flex-col" data-id="element-558">
      <PageHeader title="我的订单" data-id="element-559" />
      <div className="flex-1 flex flex-col items-center justify-center text-slate-400" data-id="element-560">
        <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mb-3" data-id="element-561">
          <span className="text-2xl" data-id="element-562">📦</span>
        </div>
        <div className="text-sm" data-id="element-563">暂无订单记录</div>
      </div>
    </div>;
}